import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, Transition as _Transition, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "-mx-6 w-[calc(100%+32px)] pb-6"
}
const _hoisted_2 = { class: "mx-6 mt-8 border rounded-lg border-neutral-100" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = { class: "flex space-x-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-semibold text-neutral-900" }, "Filter", -1)
const _hoisted_6 = { class: "flex px-4 py-3 space-x-2 transition bg-white border rounded cursor-pointer border-neutral-100 hover:bg-primary-100" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-semibold text-neutral-900" }, "Sort", -1)
const _hoisted_8 = { class: "p-6 overflow-hidden bg-white rounded-lg shadow-md ring-1 ring-black/5 sort" }
const _hoisted_9 = { class: "flex flex-col w-auto space-y-2 bg-white" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("hr", { class: "my-4" }, null, -1)
const _hoisted_11 = { class: "flex flex-col w-auto space-y-2 bg-white" }
const _hoisted_12 = { class: "space-y-5" }
const _hoisted_13 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_14 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_15 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_16 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_17 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_18 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_19 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_20 = { class: "w-full px-6 border-t py-7" }

import { onMounted, ref, watch } from 'vue';
import UserLayout from "@/layouts/UserLayout.vue"; 
import DataTable from '@/components/partials/DataTable.vue';
import ExportButton from '@/components/buttons/ExportButton.vue';
import SimplePagination from "@/components/partials/SimplePagination.vue";
import DatePicker from "@/components/inputs/DatePicker.vue";
import RadioGroup from "@/components/inputs/RadioGroup.vue";
import MultiSelect from "@/components/inputs/MultiSelect.vue";
import FilterPanel from "@/components/partials/FilterPanel.vue";
import LoadingModal from '@/components/modals/LoadingModal.vue';
import { FunnelIcon, ArrowsUpDownIcon } from "@heroicons/vue/24/outline";
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue'; 
import { items } from '@/interfaces/pages/FilterPageInterface';
import ReportService from '@/classes/Reports/ReportService';

import isNil from "lodash/isNil";
import omitBy from "lodash/omitBy";
import debounce from "lodash/debounce";


export default /*#__PURE__*/_defineComponent({
  __name: 'ReportCaseload',
  setup(__props) {

const showFilter = ref<boolean>(false); 
const loading = ref<boolean>(false);

const sortOptions = [
    { id: '1', label: 'Created', value: 'created_at'}, 
]
const orderOptions = [
    { id: '1', label: 'Ascending', value: 'asc'},
    { id: '2', label: 'Descending', value: 'desc'},
]
const interventionTypeOptions = [
    {id: 0, value: 0, label: "Social Work", description: "Social Work"},
    {id: 1, value: 1, label: "Medical", description: "Medical"},
    {id: 2, value: 2, label: "Mental", description: "Mental"},
    {id: 3, value: 3, label: "Development", description: "Development"},
    {id: 4, value: 4, label: "Legal", description: "Legal"},
    {id: 5, value: 5, label: "Teleconsultation", description: "Teleconsultation"},
    {id: 6, value: 6, label: "Telepsychiatry", description: "Telepsychiatry"},
    {id: 7, value: 7, label: "Admin", description: "Admin"},
];
const headers: { text: string }[] = [
    { text: 'Office' },
    { text: 'Personnel' },
    { text: 'Intervention' },  
    { text: 'Patient Case No.' },  
    { text: 'Patient' },  
    { text: 'Gender ' },
    { text: 'Age' },    
];
 
const filters = ref({
    page: 1,
    rows: 10,
    query: null,    
    created_at: null,
    intervention_type:null,
    column: 'created_at',
    order: 'asc',
});

const paginate = ( page:number, rows:number )=>{
    ReportService.paginate(page, rows,filters.value, getData)
}

const applyFilters = () => {
	showFilter.value = false;   
    paginate( 1, filters.value.rows);
};

const applyReset = () => {
    showFilter.value = false; 
    filters.value.created_at = null;
    filters.value.intervention_type = null;
    paginate( 1, filters.value.rows);
};
 
const getData =  (): void =>{
    loading.value = true; 
    ReportService.index('case-load',omitBy(filters.value, isNil))
        .then(({data})=>{ 
            items.value = data; 
        })
        .catch((error: any)=>{
            console.log(error)
        })
        .finally(() => {
            loading.value = false;
        })
} 

const exporting = (): void => {
    loading.value = true;
    ReportService.export('case-load',omitBy(filters.value, isNil))
        .then(({data})=>{
             ReportService.downloadExport("case-load-export.csv",data);  
        })
        .finally(() => loading.value = false)
}

watch(
    () => filters.value.query,
    debounce(() => { 
        paginate( 1, filters.value.rows);
        applyReset();
    }, 500)
);
 
onMounted(()=> {  
    getData();
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserLayout, {
    hasBack: "",
    backTitle: "Caseload Reports",
    backLink: "/reports"
  }, {
    lowerRight: _withCtx(() => [
      _createVNode(ExportButton, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (exporting()))
      })
    ]),
    default: _withCtx(() => [
      (!loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(DataTable, {
                  hasSearch: true,
                  searchPlaceholder: "Search Office, Personnel, Patient",
                  headers: headers,
                  "no-action": true,
                  count: _unref(items)?.data?.length,
                  tableClass: "header-frm-table",
                  dataTableClass: "border-0",
                  search: filters.value.query,
                  "onUpdate:searchText": _cache[11] || (_cache[11] = (value) => (filters.value.query = value))
                }, {
                  topContent: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", {
                        class: "flex px-4 py-3 space-x-2 transition bg-white border rounded cursor-pointer border-neutral-100 hover:bg-primary-100",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (showFilter.value = true))
                      }, [
                        _createVNode(_unref(FunnelIcon), { class: "inline-block w-5 h-5 text-neutral-900" }),
                        _hoisted_5
                      ]),
                      _createVNode(_unref(Popover), { class: "relative" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(PopoverButton), null, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_6, [
                                _createVNode(_unref(ArrowsUpDownIcon), { class: "inline-block w-5 h-5 text-neutral-900" }),
                                _hoisted_7
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_Transition, {
                            "enter-active-class": "transition duration-200 ease-out",
                            "enter-from-class": "translate-y-1 opacity-0",
                            "enter-to-class": "translate-y-0 opacity-100",
                            "leave-active-class": "transition duration-150 ease-in",
                            "leave-from-class": "translate-y-0 opacity-100",
                            "leave-to-class": "translate-y-1 opacity-0"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(PopoverPanel), { class: "absolute right-0 z-10 mt-3 w-fit" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_8, [
                                    _createElementVNode("div", _hoisted_9, [
                                      _createVNode(RadioGroup, {
                                        options: sortOptions,
                                        modelValue: filters.value.column,
                                        "onUpdate:modelValue": [
                                          _cache[2] || (_cache[2] = ($event: any) => ((filters.value.column) = $event)),
                                          _cache[3] || (_cache[3] = ($event: any) => (getData()))
                                        ]
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _hoisted_10,
                                    _createElementVNode("div", _hoisted_11, [
                                      _createVNode(RadioGroup, {
                                        options: orderOptions,
                                        modelValue: filters.value.order,
                                        "onUpdate:modelValue": [
                                          _cache[4] || (_cache[4] = ($event: any) => ((filters.value.order) = $event)),
                                          _cache[5] || (_cache[5] = ($event: any) => (getData()))
                                        ]
                                      }, null, 8, ["modelValue"])
                                    ])
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(FilterPanel, {
                        show: showFilter.value,
                        onClose: _cache[8] || (_cache[8] = ($event: any) => (showFilter.value = false)),
                        "onApply:reset": _cache[9] || (_cache[9] = ($event: any) => (applyReset())),
                        "onApply:filters": _cache[10] || (_cache[10] = ($event: any) => (applyFilters())),
                        customClass: "!overflow-visible overflow-x-visible"
                      }, {
                        fields: _withCtx(() => [
                          _createElementVNode("div", _hoisted_12, [
                            _createVNode(DatePicker, {
                              id: "created_at",
                              name: "created_at",
                              label: "Date Encoded",
                              modelValue: filters.value.created_at,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((filters.value.created_at) = $event)),
                              range: "",
                              multiCalendars: "",
                              class: "filter-range"
                            }, null, 8, ["modelValue"]),
                            _createVNode(MultiSelect, {
                              options: interventionTypeOptions,
                              modelValue: filters.value.intervention_type,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((filters.value.intervention_type) = $event)),
                              id: "intervention",
                              name: "intervention",
                              label: "Intervention",
                              placeholder: "Select.."
                            }, null, 8, ["modelValue"])
                          ])
                        ]),
                        _: 1
                      }, 8, ["show"])
                    ])
                  ]),
                  body: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(items).data, (item) => {
                      return (_openBlock(), _createElementBlock("tr", { key: item }, [
                        _createElementVNode("td", _hoisted_13, _toDisplayString(item?.office), 1),
                        _createElementVNode("td", _hoisted_14, _toDisplayString(item?.personnel), 1),
                        _createElementVNode("td", _hoisted_15, _toDisplayString(item?.intervention), 1),
                        _createElementVNode("td", _hoisted_16, _toDisplayString(item?.case_no), 1),
                        _createElementVNode("td", _hoisted_17, _toDisplayString(item?.patient), 1),
                        _createElementVNode("td", _hoisted_18, _toDisplayString(item?.gender), 1),
                        _createElementVNode("td", _hoisted_19, _toDisplayString(item?.age), 1)
                      ]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["count", "search"]),
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(SimplePagination, {
                    numRows: filters.value?.rows ?? 10,
                    currentPage: _unref(items)?.current_page,
                    "last-page": _unref(items)?.last_page,
                    onUpdate: _cache[12] || (_cache[12] = (value) => paginate(value.page, value.rows))
                  }, null, 8, ["numRows", "currentPage", "last-page"])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode(LoadingModal, {
        show: loading.value,
        noBtn: "",
        title: "Please wait..",
        content: "System is currently loading the report based on the selected filter."
      }, null, 8, ["show"])
    ]),
    _: 1
  }))
}
}

})